module.exports = __webpack_public_path__ + "img/icons/new/dropdown-a2ce7234860ae43e3a61899beb6659f3.png";